<template>
  <div class="disbursement-details">
    <div class="disbursement-detail-section">
      <div class="disbursement-detail">
        <span>Status Last Updated:&nbsp;</span>
        <span class="fw-700">{{ lastUpdated }}</span>
      </div>
    </div>
    <div class="disbursement-detail-section">
      <div class="disbursement-detail">
        <span>Estimated Disbursement Date:&nbsp;</span>
        <span class="fw-700"
          >{{ estimatedDisbursementDate }}&nbsp;
          <Icon
            icon="info-green"
            popovertarget="disbursement-amount"
            aria-describedby="mobile-tip"
            color="#008000"
            class="anchor-btn"
          />
          <div ref="disbAmountPopoverRef" id="disbursement-amount" popover>
            <DisbursementAmountTotal
              :totalAmount="disbursementGroup?.totalAmountDisplay"
              :count="disbursementGroup?.count || 0"
            />
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/shared/Icon.vue";
import DisbursementAmountTotal from "@/components/certification-updates/DisbursementAmountTotal.vue";
import type { DisbursementGroupModel, DisbursementModelVM } from "@/models/disbursementService";
import type { CertificationModelVM } from "@/models/certificationService";
import { computed } from "vue";

const props = defineProps<{
  certification: CertificationModelVM;
  disbursement: DisbursementModelVM;
  disbursementGroups?: Record<string, DisbursementGroupModel[]>;
}>();

const disbursementGroup = computed<DisbursementGroupModel | undefined>(() => {
  if (!props.disbursementGroups || Object.keys(props.disbursementGroups)?.length === 0) {
    return undefined;
  }

  const filteredDisbGroups = props.disbursementGroups[`${props?.certification?.details?.status}`];

  if (filteredDisbGroups?.length > 0) {
    return filteredDisbGroups[0];
  }

  return undefined;
});

const estimatedDisbursementDate = computed<string>(() => {
  if (disbursementGroup.value) return disbursementGroup.value?.estimatedDisbursementDate;

  return props.disbursement?.estimatedDisbursementDate;
});

const lastUpdated = computed<string>(() => {
  if (disbursementGroup.value) return disbursementGroup.value?.lastUpdated;

  return props.disbursement?.lastUpdated;
});
</script>

<style scoped src="@/styles/certification-updates/base.css"></style>
<style scoped src="@/styles/popovers/base.css"></style>

<style scoped>
/* If the icon is hovered, show the popover */
/* If the icon is focused, show the popover */
.disbursement-details:has([popovertarget="disbursement-amount"]:hover) [popover],
.disbursement-details:has([popovertarget="disbursement-amount"]:focus) [popover] {
  display: block;
  opacity: 1;
}

/* 1. Name the trigger button as an anchor */
.anchor-btn {
  anchor-name: --my-anchor;
}
/* 2. Position the popover relative to that anchor */
#disbursement-amount {
  position: absolute;
  position-anchor: --my-anchor;
  margin: 0;
  inset: auto;
  bottom: anchor(top);
  justify-self: anchor-center;
}

.icon.info-green:before,
.icon.circle-money-green:before {
  font-size: 18px;
  font-weight: 700;
}

@media (width <= 568px) {
  .icon.info-green:before,
  .icon.circle-money-green:before {
    font-size: 25px;
    font-weight: 700;
  }
}
</style>
